import React from 'react';
import { Box } from '@mui/material';

export const Spacer = () => {
  return <Box sx={{ flexGrow: 1 }} />;
};
